import ParticipantsCheckbox from './ParticipantsCheckbox'

export default ParticipantsCheckbox
